import React from 'react'
import { Label } from '@workwhile/ui'
import {
  JET_ALERT_TYPE_LABELS,
  JET_ALERT_TYPE_LABEL_VARIANTS,
  JetAlertType,
} from 'pages/Jet/shared/constants/alertType'

export const JetAlertTypeBadge = ({
  alertType,
}: {
  alertType: JetAlertType
}) => (
  <Label
    variant={JET_ALERT_TYPE_LABEL_VARIANTS[alertType]}
    size="small"
    style={{ whiteSpace: 'nowrap', padding: '0 0.5rem' }}
  >
    {JET_ALERT_TYPE_LABELS[alertType]}
  </Label>
)
